import type { Module, ActionContext } from 'vuex';

import type { IAppState } from '../../constants';
import { SET_REQUIRE_BETTING_LIMIT } from './responsible-gaming.constants';
import type { IResponsibleGamingState } from './responsible-gaming.constants';
import { magic } from '@gig/magic-sdk';
import {
    GamingLimitType,
    GamingLimitDuration,
} from '@gig/magic-sdk/dist/adapter/responsiblegaming/setUserLimits';

export const getters = {
    requireBettingLimit(state: IResponsibleGamingState) {
        return state.requireBettingLimit;
    },
};

export const actions = {
    /**
     * Sets requireBettingLimit false if the user has the betting limits set
     */
    async setRequireBettingLimit({
        commit,
    }: ActionContext<IResponsibleGamingState, IAppState>) {
        const limits = await magic.methods.responsibleGaming.getUserLimits();

        const mandatoryLimits = limits.activeLimits.filter(
            ({ limitTypeId, durationId }) => {
                return (
                    (limitTypeId === GamingLimitType.WAGERING &&
                        durationId === GamingLimitDuration.ONE_DAY) ||
                    limitTypeId === GamingLimitType.MAX_STAKE_PER_BET
                );
            },
        );

        commit(SET_REQUIRE_BETTING_LIMIT, mandatoryLimits.length < 1);
        return mandatoryLimits.length < 1;
    },
    clearLimits({ commit }: ActionContext<IResponsibleGamingState, IAppState>) {
        commit(SET_REQUIRE_BETTING_LIMIT, null);
    },
};

export const responsibleGaming: Module<IResponsibleGamingState, IAppState> = {
    namespaced: true,
    state: {
        requireBettingLimit: null,
    },
    getters,
    actions,
    mutations: {
        [SET_REQUIRE_BETTING_LIMIT](state, payload: boolean) {
            state.requireBettingLimit = payload;
        },
    },
};
